var _excluded = ["profile"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ReactPlayer from 'react-player';
import { withMedia } from 'react-media-query-hoc';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import AgentStats from '@domain-group/fe-co-allhomes-agent-stats';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import AllhomesCollapsibleDescription from '@domain-group/fe-co-allhomes-collapsible-description';
import { AllhomesAgentCardHeader } from './header-card';
import AllhomesAgentModel from './agent-model';
import { AgentAwards } from './agent-awards';
import getCardProps from './get-card-props';
var Info = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-agent-profile/static/info_951c19ac.png";
import * as styles from './agent-body.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentBody = _ref => {
  var _profile$memberships, _profile$awards;
  var profile = _ref.profile,
    props = _objectWithoutProperties(_ref, _excluded);
  var mobile = props.media.mobile;
  var agencyLogo = get(profile.agency, 'images.profilePhoto');
  var hasValue = function hasValue() {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    return values.some(val => val && val !== '0' && val !== '-');
  };
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var videoPlayer = ___EmotionJSX(ReactPlayer, {
    url: profile.videoUrl,
    controls: true,
    onStart: () => sendEvent('video-click'),
    width: "100%",
    height: "100%"
  });
  var descriptionBlock = ___EmotionJSX("div", {
    css: styles.descriptionBlock
  }, !mobile && ___EmotionJSX("h1", {
    css: styles.agentDescriptionHeading
  }, "About ", profile.name), ___EmotionJSX("div", {
    css: styles.videoColumn
  }, videoPlayer), ___EmotionJSX("div", {
    css: styles.collapsibleDescription
  }, ___EmotionJSX(AllhomesCollapsibleDescription, {
    description: profile.description,
    maxPreviewHeight: props.maxPreviewHeight,
    onClick: () => sendEvent('expand-description'),
    showLabelMobile: "About ".concat(profile.name)
  })));
  return ___EmotionJSX("div", {
    css: styles.body
  }, ___EmotionJSX("div", {
    css: styles.topSection
  }, ___EmotionJSX("div", {
    css: styles.cardContainer
  }, ___EmotionJSX(AllhomesAgentCardHeader, _extends({}, getCardProps(profile), {
    onEmailClick: props.onEmailClick
  }))), ___EmotionJSX("div", {
    css: styles.right
  }, !mobile && ___EmotionJSX("div", {
    css: styles.agencyInfoBox
  }, agencyLogo && (profile.brandingLevel !== 'PLATINUM' || !toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING]) && ___EmotionJSX("a", {
    href: profile.agency.profileUrl,
    onClick: () => sendEvent('agency-logo-click')
  }, ___EmotionJSX("div", {
    css: styles.agencyLogoBox(profile.agency.logoBackgroundColour)
  }, ___EmotionJSX("img", {
    css: styles.agencyLogo,
    src: agencyLogo,
    alt: profile.agency.name
  }))), ___EmotionJSX("div", {
    css: styles.agencyDetails
  }, ___EmotionJSX("h1", {
    css: styles.agencyName
  }, profile.agency.name), ___EmotionJSX("div", null, ___EmotionJSX("a", {
    css: styles.agencyProfileLink,
    href: profile.agency.profileUrl
  }, "View agency profile")))), descriptionBlock)), (((_profile$memberships = profile.memberships) === null || _profile$memberships === void 0 ? void 0 : _profile$memberships.length) > 0 || ((_profile$awards = profile.awards) === null || _profile$awards === void 0 ? void 0 : _profile$awards.length) > 0) && ___EmotionJSX(AgentAwards, {
    awards: profile.awards,
    memberships: profile.memberships,
    agencyName: profile.name
  }), hasValue(profile.stats.sold, profile.stats.forSale, profile.stats.averageDays, profile.stats.rented, profile.stats.forRent, profile.stats.soldDevelopments, profile.stats.developments, profile.stats.soldDevelopmentsSecondary, profile.stats.rentedSecondary, profile.stats.soldSecondary) && ___EmotionJSX("div", {
    css: styles.stats
  }, ___EmotionJSX("div", {
    css: styles.statsInfo
  }, ___EmotionJSX("img", {
    src: Info,
    alt: "",
    css: styles.infoImage
  }), ___EmotionJSX("span", {
    css: styles.infoMessage
  }, "Listing counts are for properties advertised on Allhomes in last 12 months")), ___EmotionJSX(AgentStats, {
    soldAll: profile.stats.sold,
    saleAll: profile.stats.forSale,
    averageDaysAll: profile.stats.averageDays,
    rentedAll: profile.stats.rented,
    rentAll: profile.stats.forRent,
    soldDevelopmentsAll: profile.stats.soldDevelopments,
    developmentsAll: profile.stats.developments,
    soldDevelopmentsSecondary: profile.stats.soldDevelopmentsSecondary,
    rentedSecondary: profile.stats.rentedSecondary,
    soldSecondary: profile.stats.soldSecondary,
    fixedHeight: true
  })));
};
AllhomesAgentBody.propTypes = {
  profile: PropTypes.shape(AllhomesAgentModel).isRequired,
  maxPreviewHeight: PropTypes.number,
  onEmailClick: PropTypes.func.isRequired,
  media: PropTypes.shape({
    desktop: PropTypes.bool,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool
  })
};
AllhomesAgentBody.defaultProps = {
  maxPreviewHeight: undefined,
  media: {}
};
export default withMedia(AllhomesAgentBody);